import { useEffect } from 'react';

/**
 * useCrossTabJump — lets any component in the dashboard tree ask the
 * top-level Tabs to hop to another tab, without prop-drilling.
 *
 * Usage: mount once inside Dashboard with `useCrossTabJump(setActiveTab)`.
 * Elsewhere, fire:
 *   window.dispatchEvent(new CustomEvent('mif:go-to-tab', { detail: 'settings' }));
 */
export default function useCrossTabJump(setActiveTab) {
  useEffect(() => {
    const handler = (e) => {
      const target = e?.detail;
      if (typeof target === 'string' && typeof setActiveTab === 'function') {
        setActiveTab(target);
      }
    };
    window.addEventListener('mif:go-to-tab', handler);
    return () => window.removeEventListener('mif:go-to-tab', handler);
  }, [setActiveTab]);
}
